import React, { createContext, useCallback, useReducer } from 'react';
import { useDispatch } from 'react-redux';

import { SAGA_FAIL, SAGA_INIT, SAGA_LOADING, SAGA_SUCCESS } from '../../../common';

export const ProductContext = createContext();

const setProductSuccess = 'setProductSuccess';
const setProductFail = 'setProductFail';
const setProductReset = 'setProductReset';
const setProductLoading = 'setProductLoading';

const initialState = {
  product: undefined,
  ...SAGA_INIT
};

const reducer = (state, action) => {
  switch (action.type) {
    case setProductSuccess:
      return {
        ...state,
        product: action.payload,
        ...SAGA_SUCCESS
      }
    case setProductFail:
      return {
        ...state,
        product: null,
        ...SAGA_FAIL
      }
    case setProductReset:
      return {
        ...initialState
      }
    case setProductLoading:
      return {
        ...state,
        ...SAGA_LOADING
      }
    default:
      throw new Error()
  }
};

const ProductProvider = props => {
  const { children } = props;
  const dispatch = useDispatch();
  const [productState, dispatchReducer] = useReducer(reducer, initialState);

  const getProduct = useCallback(
    id => {
      dispatch({
        type: 'PRODUCT',
        payload: {
          params: { id },
          onStart: () => {
            dispatchReducer({ type: setProductLoading });
          },
          onSuccess: data => {
            const { product } = data;
            dispatchReducer({
              type: setProductSuccess,
              payload: product
            });
          },
          onError: () => {
            dispatchReducer({ type: setProductFail });
          }
        }
      });
    },
    [dispatch, dispatchReducer]
  );

  return (
    <ProductContext.Provider value={{ getProduct, productState }}>
      {children}
    </ProductContext.Provider>
  );
};

export default ProductProvider;